import React from 'react'
import { Modal } from 'react-bootstrap'
import { useSelector } from 'react-redux';

const HouseHoldInviteModal = ({ houseHoldSuccesModal }) => {
    const userPrompts = useSelector((state) => state.user.userPrompts);

    return (
        <>
            <Modal
                show={houseHoldSuccesModal}
                centered
                className="success-modal"
                backdrop="static"
            >
                <Modal.Body>
                    <div className="p-5 px-3">
                        <h2 className="font-16 lh-16 my-5 fw-normal text-center">{userPrompts?.email_invite_message}</h2>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default HouseHoldInviteModal